import { useMutation } from '@tanstack/react-query';
import { showcaseApi } from '../api/showcaseApi';
import type { ApiError, BarcodeGenerateRequest, BarcodeGenerateResponse } from '../types/showcase';

/** C081 바코드/QR 데모(순수) — POST .../barcode/generate (queue #646 §R646-2). */
export function useBarcodeGenerate() {
  return useMutation<BarcodeGenerateResponse, ApiError, BarcodeGenerateRequest>({
    mutationFn: (req) => showcaseApi.barcodeGenerate(req),
    mutationKey: ['common-showcase', 'barcode', 'generate'],
  });
}
